import uzLatn from 'dayjs/locale/uz-latn';
import { toNewLatin } from '@kitobxonlik/contracts';

/** dayjs'ning `uz-latn` lokali — kun nomlari eski imloda (`Chorshanba`) keladi */
export const dayjsLocale = {
  ...uzLatn,
  weekdays: uzLatn.weekdays?.map((day) => toNewLatin(day)),
  weekdaysShort: uzLatn.weekdaysShort?.map((day) => toNewLatin(day)),
  weekdaysMin: uzLatn.weekdaysMin?.map((day) => toNewLatin(day)),
};
